import axios, { AxiosResponse } from 'axios';

const VITE_PASSWORD_API_URL=  import.meta.env.VITE_PASSWORD_API_URL;

interface ResetPasswordParams {
	emailAddress: string;
	recaptchaToken: string;
}

export const resetPassword = async (
  params: ResetPasswordParams,
  language: string,
): Promise<AxiosResponse> => axios.post(`${VITE_PASSWORD_API_URL}/password/reset`, params, {
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': language,
  },
});

interface ChangePasswordParams {
	newPassword: string;
	newPasswordDoubleCheck: string;
	recaptchaToken: string;
	resetToken: string;
}

export const changePassword = async (params: ChangePasswordParams, language: string): Promise<AxiosResponse> => axios.post(`${VITE_PASSWORD_API_URL}/password/change`, params, {
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': language,
  },
});

interface ValidatePasswordParams {
	newPassword: string;
	newPasswordDoubleCheck: string;
	recaptchaToken: string;
}

export const validatePassword = async (params: ValidatePasswordParams, language: string): Promise<AxiosResponse> => axios.post(`${VITE_PASSWORD_API_URL}/password/validate`, params, {
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': language,
  },
});

export const validationRules = async (language: string): Promise<AxiosResponse> => axios.get(`${VITE_PASSWORD_API_URL}/Password/GetPasswordValidationRules`, {
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': language,
  },
});
